import vehicleOwnerService from '../services/VehicleOwnerService.js';

export function findOwnerIdForVehicle(vehicleOwners, vehicleId) {
  const vid = Number(vehicleId);
  if (!vid) return '';
  for (const owner of vehicleOwners || []) {
    const list = owner.vehicles || [];
    if (list.some((v) => Number(v) === vid)) {
      return owner.vehicle_owner_id;
    }
  }
  return '';
}

export function validateVehicleOwnerAssignment({
  ownerMode,
  selectedOwnerId,
  newOwnerData = {},
  ownerPercentageOverride = '',
  vehicleOwners = [],
  hasCommission = false,
}) {
  if (!ownerMode || ownerMode === 'none') return null;

  if (ownerMode === 'existing') {
    if (!selectedOwnerId) return 'Please select a vehicle owner';
    return null;
  }

  if (ownerMode === 'new') {
    if (!newOwnerData.owner_name?.trim()) return 'Vehicle owner name is required';
    if (!newOwnerData.contact?.trim()) return 'Vehicle owner contact is required';
  }

  return null;
}

export async function syncVehicleOwnerAssignment({
  vehicleId,
  ownerMode,
  selectedOwnerId,
  vehicleOwners = [],
  newOwnerData = {},
  ownerPercentageOverride = '',
  previousOwnerId = '',
}) {
  const vid = Number(vehicleId);
  if (!vid) return;

  const removeFromOwner = async (ownerId) => {
    if (!ownerId) return;
    const owner = vehicleOwners.find((o) => o.vehicle_owner_id === ownerId);
    if (!owner) return;
    const updated = (owner.vehicles || []).map(Number).filter((id) => id !== vid);
    await vehicleOwnerService.update(ownerId, { vehicles: updated });
  };

  if (ownerMode === 'none' || !ownerMode) {
    await removeFromOwner(previousOwnerId);
    return;
  }

  if (ownerMode === 'new') {
    if (previousOwnerId) await removeFromOwner(previousOwnerId);
    await vehicleOwnerService.create({
      owner_name: newOwnerData.owner_name.trim(),
      contact: newOwnerData.contact.trim(),
      email: newOwnerData.email?.trim() || undefined,
      vehicles: [vid],
      owner_percentage:
        newOwnerData.owner_percentage !== '' && newOwnerData.owner_percentage != null
          ? Number(newOwnerData.owner_percentage)
          : null,
    });
    return;
  }

  if (ownerMode === 'existing' && selectedOwnerId) {
    if (previousOwnerId && previousOwnerId !== selectedOwnerId) {
      await removeFromOwner(previousOwnerId);
    }
    const owner = vehicleOwners.find((o) => o.vehicle_owner_id === selectedOwnerId);
    const existing = (owner?.vehicles || []).map(Number);
    const updatedVehicles = existing.includes(vid) ? existing : [...existing, vid];
    const updatePayload = { vehicles: updatedVehicles };
    if (ownerPercentageOverride !== '' && ownerPercentageOverride != null) {
      updatePayload.owner_percentage = Number(ownerPercentageOverride);
    }
    await vehicleOwnerService.update(selectedOwnerId, updatePayload);
  }
}
